import React, { useEffect } from "react";
import Stage from "../../../../../components/Stage";
import ButtonBack from "../../../../../components/Buttons/Back";

const ThankYou = () => {
    useEffect(() => {
        document.title = "Gracias - Tu próximo Audi te espera";
    }, []);

    return (
        <>
            <div className="">
                <Stage title="Tu próximo Audi te espera" img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/form_ducati_home_respuesta.png"} positionTitle="bottom" />
                <div className="button-back-container">
                    <ButtonBack pagesToBack={2} />
                </div>
                <section className="container pb-5">
                    <div className="row pt-5">
                        <div className="col-12 mt-5">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando tu solicitud. Un asesor de nuestro equipo se pondrá en contacto contigo a la brevedad.</p>
                            <div className="text-center mb-5 pb-5">
                                <button className='button-enviar mt-5 mb-5' type='button' onClick={() =>
                                    (window.location = "https://www.audi.com.mx/mx/web/es.html")
                                }>
                                    Ir al Home
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYou;